module.exports = __webpack_public_path__ + "img/bg1.ab695271.png";